'use strict';
var React = require('react');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var Border = require('../common/Border');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var _ = require('underscore');

var TitleWindow = React.createClass({

  render: function () {
    var showScrollBar;
    var value = styleHelper.getInt(this.props, propConst.VERTICAL_SCROLL_BAR_PROGRESS);

    var h = styleHelper.getHeight(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);

    var titleStyle = {
      height: this.props.topHeight,
      lineHeight: this.props.topHeight + 'px',
      zIndex: 2
    };
    var contentStyle = {
      top: parseInt(this.props.topHeight, 10),
      height: h - this.props.topHeight - this.props.bottomHeight - 4,
      backgroundColor: bgColor,
      zIndex: 1
    };

    var statusStyle = {
      height: this.props.bottomHeight,
      zIndex: 3
    };
    var labelStyle = {
      height: this.props.topHeight,
      lineHeight: this.props.topHeight + 'px'
    };
    var style = styleHelper.StyleUtil(this.props).size().default({border: '2px solid #444',boxSizing:'border-box'}).text().background().style;

    /*border相关兼容修正*/
    if(this.props.borderVisible){
      style.border = '2px solid ' + this.props.borderColor;
      titleStyle.borderBottom = '1px solid ' + this.props.borderColor;
      statusStyle.borderTop = '1px solid ' + this.props.borderColor;
      style.borderColor = styleHelper.getBorderColor(this.props);
      titleStyle.borderColor = styleHelper.getBorderColor(this.props);
    }else{
      style.border = 'none';
    }


    showScrollBar = this.props.verticalScrollbarShow;
    return (<div className="component" style={style}>
      <div ref="title" className="title" style={titleStyle}>
        <label style={labelStyle}>
          {styleHelper.getText(this.props)}
        </label>
        <div className="icon-box" style={{height:'auto',right : 6, bottom : (this.props.topHeight - 12) / 2 - 6}}>
          {
            this.props.showMin && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_min')}/>)
          }
          {
            this.props.showMax && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_max')}/>)
          }
          {
            this.props.showClose && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_close')}/>)
          }
        </div>
      </div>
      <div ref="content" className="content" style={contentStyle}>
        {
          showScrollBar && (<VerticalScrollBar { ...{
            value: value,
            right: -1,
            height: '100%'
          }}/>)
        }
      </div>
      <div ref="bottom" className="status-bar" style={statusStyle}>
        <div className="icon-box">
          {
            this.props.showDrag && (
              <img width="12" height="12" className="win-icon"
                   src={assetsHelper.getComponentAsset('window_drag')}/>
            )
          }
        </div>
      </div>
    </div>);
  }

});

module.exports = TitleWindow;



// WEBPACK FOOTER //
// ./src/views/Components/TitleWindow.jsx